import React, {Suspense} from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
} from 'react-router-dom';
import './scss/style.scss';
import PublicLayout from './components/public/layout/PublicLayout';
import Auth from './components/public/auth/Auth';
import NoMatch from './shared/components/NoMatch';
import PrivateLayout from './components/private/layout/PrivateLayout';
import WeatherStations from './components/private/weather-stations/WeatherStations';
import CashBids from './components/private/cash-bids/CashBids';
import Reports from './components/private/reports/Reports';
import MyFields from './components/private/mapping/MyFields';
import MapMyFields from './components/private/mapping/MapMyFields';
import NetOfFreight from './components/private/mapping/NetOfFreight';
import NutrientRemoval from './components/private/mapping/NutrientRemoval';
import FertilizerVsCornFutures from './components/private/agronomy/FertilizerVsCornFutures';
import PhantomYieldLossCalculator from './components/private/tool-box/PhantomYieldLossCalculator';
import YieldEstimator from './components/private/tool-box/YieldEstimator';
import BrowserCheck from './components/private/support/BrowserCheck';
import AppleRequirements from './components/private/support/AppleRequirements';
import CarbonScoring from './components/private/tool-box/CarbonScoring';
import MarketingPlan from './components/private/marketing-plan/MarketingPlan';

const loading = (
  <div className='pt-3 text-center'>
    <div className='sk-spinner sk-spinner-pulse'></div>
  </div>
);

const App = () => {

  return (
    <BrowserRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route element={<PublicLayout />} path=''>
            <Route element={<Auth />} path='' />
          </Route>
          <Route element={<PrivateLayout />} path='premierplus'>
            <Route element={<CashBids />} path='cash-bids' />
            <Route element={<WeatherStations />} path='weather-stations' />
            <Route element={<Reports />} path='reports' />
            <Route element={<MyFields />} path='mapping/my-fields' />
            <Route element={<MapMyFields />} path='mapping/map-my-fields' />
            <Route element={<NetOfFreight />} path='mapping/net-of-freight' />
            <Route element={<NutrientRemoval />} path='mapping/nutrient-removal' />
            <Route element={<FertilizerVsCornFutures />} path='agronomy/fertilizer-vs-corn-futures' />
            <Route element={<PhantomYieldLossCalculator />} path='tool-box/phantom-yield-loss-calculator' />
            <Route element={<YieldEstimator />} path='tool-box/yield-estimator' />
            <Route element={<CarbonScoring />} path='tool-box/carbon-scoring' />
            <Route element={<MarketingPlan />} path='marketing-plan' />
            <Route element={<BrowserCheck />} path='support/browser-check' />
            <Route element={<AppleRequirements />} path='support/apple-requirements' />
          </Route>
          <Route element={<NoMatch />} path='*' />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
